import React, {useEffect} from 'react';
import {Provider} from 'react-redux';
import {QueryParamProvider} from 'use-query-params';
import {Routes} from './routes/Routes';
import {store} from './state/store';
import {Router, Route} from 'react-router-dom';
import {createBrowserHistory} from 'history';
import {Auth} from './containers/auth/Auth';
import {UserMiddleware} from './containers/auth/components/UserMiddleware/UserMiddleware';
import './index.scss';
import {ACCESS_TOKEN, routerBasename} from "./config";
import {setCookie} from "./utils/helpers";
import {userInfoApi} from "./state/user_info";
import {Redirect} from "react-router";
import {ApiRequestPreloader} from "./components";

const history = createBrowserHistory({window, basename: routerBasename});
// const accessToken ="eyJraWQiOiIrQ3BUbTZzalAyK0R3Yk9LWGY3U1NuWGFIekhpbEpaWGhGZlREaWFRdFZBPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiJjYjc2Y2E3NS1iNGU2LTRkZDktYTljZC0yYWZiMWExMWNlNTAiLCJjb2duaXRvOmdyb3VwcyI6WyJ1cy1lYXN0LTFfUlBiRll0NEsyX21kdC1hZCJdLCJpc3MiOiJodHRwczovL2NvZ25pdG8taWRwLnVzLWVhc3QtMS5hbWF6b25hd3MuY29tL3VzLWVhc3QtMV9SUGJGWXQ0SzIiLCJ2ZXJzaW9uIjoyLCJjbGllbnRfaWQiOiI3OWxnMXJlZzljZzBwaGJhbW1rYjE2aWxsYyIsIm9yaWdpbl9qdGkiOiIwYWI1OWVkOC0zMjM4LTRhMzgtODBiZS03MmUyYjczZWFjMjkiLCJ0b2tlbl91c2UiOiJhY2Nlc3MiLCJzY29wZSI6ImF3cy5jb2duaXRvLnNpZ25pbi51c2VyLmFkbWluIHBob25lIG9wZW5pZCBwcm9maWxlIGVtYWlsIiwiYXV0aF90aW1lIjoxNzg4ODA0NTY4LCJleHAiOjE3ODg4MDgxNjgsImlhdCI6MTc4ODgwNDU2OCwianRpIjoiNTNjMTcxNmYtMmE5MC00ODM0LWJhNGEtM2NkN2FlMWYyNzcyIiwidXNlcm5hbWUiOiJtZHQtYWRfSlNmMmNvNUpoNU8wY1llOFQ0UkU4MDBTTC1QUzAtV05NZXhreDhudlk5byJ9.r-DBh_uLn5FaSywK4jSKhfSVxH20DQrN23nPF3beJXzkVoHXtg148yCwKpTRSYKXTE05NEZ_SIl2ujPAYFmchR17IbKxVlY_xTLkGBHuduqIL57OpaXGNMDh2KVyGkTBnytQJfJ8cKLFH8O9k5cKY3kk7P1e6t_zaFzcEYB3JhY1TWILte2kW4pnHoFzYW_g6q0VXwwe-OFwyYTYxcxQDtz8ruDarh7JlfFZ_4_w43ymJX2MmFnqsKLTjZBHH2YEoWvd5-_iJQGXoM0-ATKjNZETYhyyS2DXX31Io4QNUlx_9Mcmy1yYBJ9t4fGMkxeo1PKHR7CDmUndnk3_c5jVNw";
// localStorage.setItem(ACCESS_TOKEN, accessToken);

// setCookie('token', accessToken);
const App = () => {
    return (
        <Provider store={store}>
            <Router history={history}>
                <QueryParamProvider ReactRouterRoute={Route}>
                    <UserMiddleware>
                        <Auth/>
                        <Routes/>
                    </UserMiddleware>
                </QueryParamProvider>
            </Router>
        </Provider>
    );
};

export default App;
